<template>
    <rkm-modal
        :title="title"
        extra-large
        ref="RkmModal"
    >
        <rkm-row>
            <rkm-col cols="12">
                <div v-html="item ? item.descricao : null"></div>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        title() {
            return this.item ? `${this.item.versao} - ${this.item.titulo}` : null
        },
    },
    data: () => ({
        item: null,
    }),
    methods: {
        open(item) {
            this.item = item
            this.$refs.RkmModal.show()
        },
    },
}
</script>